/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Recentsales_Amount1Inputs */

const he_dashboard_recentsales_amount1 = /** @type {(inputs: Dashboard_Recentsales_Amount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`סכום`)
};

const en_dashboard_recentsales_amount1 = /** @type {(inputs: Dashboard_Recentsales_Amount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount`)
};

/**
* | output |
* | --- |
* | "Amount" |
*
* @param {Dashboard_Recentsales_Amount1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentsales_amount1 = /** @type {((inputs?: Dashboard_Recentsales_Amount1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentsales_Amount1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentsales_amount1(inputs)
	return en_dashboard_recentsales_amount1(inputs)
});
export { dashboard_recentsales_amount1 as "dashboard_recentSales_amount" }